// const API_URL =
//   process.env.NODE_ENV === "production"
//     ? "http://216.48.182.30:5010"
//     : "http://localhost:5000";
const API_URL =
  process.env.NODE_ENV === "production"
    ? "https://www.synergyteletech.com"
    : "http://localhost:5000";
//  const API_URL ="http://216.48.182.30:5010";


export default API_URL;